import SectionWithItems from "../../../scripts/SectionWithItems";

const projects = [
    {
        left: "Newcastle University 2019 - 2020",
        right: "MSc Game Engineering",
        image: "/images/newcastleuniversity.jpg",
        parallax1: -10,
        parallax2: 10,
        link: '/education/newcastle'
    },
    {
        left: "University of Leicester 2016 - 2019",
        right: "BSc Computer Science",
        image: "/images/leicesteruniversity.jpg",
        parallax1: -10,
        parallax2: 10,
        link: '/education/leicester'
    },
];

const LandingEducation = () =>{
    return (
        <SectionWithItems title='Education' projects={projects} />
    )
}

export default LandingEducation;